import Operation from './Operation.js';
import ResizeEvent from './ResizeEvent.js';
import ResizeResolutionChange from './ResizeResolutionChange.js';
import {RESOLUTION_CHANGE,
       SEQUENCE_ROLL} from '../constants.js';

const LEFT = 'LEFT';

class ResizeSequenceRoll extends Operation {
    constructor(mix, sequenceRollEvent, resolutionChangeEvent, direction, difference) {
        super(mix, sequenceRollEvent.getType());

        this.sequenceRollEvent = sequenceRollEvent;
        this.resolutionChangeEvent = resolutionChangeEvent;
        if (direction === LEFT) {
            this.newStart = difference;
        } else {
            this.difference = difference;
        }
        this.direction = direction;
    }

    execute() {
        if (this.direction === LEFT) {
            this.resizeLeftSide();
        } else {
            this.resizeRightSide();
        }
    }

    resizeLeftSide() {
        let subEvents = this.sequenceRollEvent.getSubEvents();
        let index = subEvents.indexOf(this.resolutionChangeEvent);
        if (index === 0) {
            this.sequenceRollEvent.step = this.newStart;
        }

        this.resolutionChangeEvent.step = this.newStart;
        this.sequenceRollEvent.calculateDurations();
    }

    resizeRightSide() {
        let step = this.sequenceRollEvent.step;
        let duration = this.sequenceRollEvent.duration;
        let subEvents = this.sequenceRollEvent.getSubEvents();

        // see where the resolutionChangeEvent lies
        let index = -1;
        for (let i in subEvents) {
            if (subEvents[i].step === this.resolutionChangeEvent.step) {
                index = parseInt(i);
            }
        }

        if (index === subEvents.length - 1) {
            // it's the last event so we need to resize the sequence roll

            // first calculate the true new size of the sequence roll, which
            // is the sum of all the resolution changes within it
            new ResizeEvent(this.mix, this.sequenceRollEvent, this.difference, true)
                .execute();
        } else {
            // other wise we need to resize the resolution change event 
            // first we need to find the actual resolution change event object
            new ResizeResolutionChange(this.sequenceRollEvent, this.resolutionChangeEvent, this.difference)
                .execute();
        }
    }

    getResolutionDuration(event) {
        // first check if the event surpasses the sequence roll event 
        let edge = event.step  + event.duration;
        let values = this.mix.getValuesBetweenSteps(SEQUENCE_ROLL, event.step, edge);
        for (let i in values) {
            if (!values[i].value) {
                return values[i].step - event.step;
            }
        }

        // otherwise just return the duration
        return event.duration;
    }
}



export default ResizeSequenceRoll;
